import { createPinia } from "pinia";
import { createApp } from "vue";
import "element-plus/theme-chalk/el-message-box.css";
import "element-plus/theme-chalk/el-message.css";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/cruise-pms-tokens.css";
import "./assets/styles/cruise-pms-fonts.scss";
import "./assets/styles/cruise-pms-element.scss";
import "./assets/styles/cruise-pms-components.scss";
import "./assets/styles/app.scss";
import "./assets/styles/mobile.scss";

createApp(App).use(createPinia()).use(router).mount("#app");
